import React, {Component} from 'react';
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc';
import _ from 'lodash';
import arrayMove from 'array-move';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import EditTeamItem from "./EditTeamItem";
import "./ContentItemDraggableList.scss";

const DragHandle = sortableHandle(() => <FontAwesomeIcon icon={faBars} className="mr-1" />);

const SortableItem = sortableElement(({ value, contents, index, type }) => {
  // console.log({value, contents})
  return (  
  <li className="dragable-item d-flex align-items-center">
    <DragHandle />
    <EditTeamItem
      key={contents[value] ? contents[value].stage : 'null_item'}
      value={value}
      stage={_.get(contents[value], 'stage', '')}
      funnelStage={contents[value] || {}}
      buttonTitle="EDIT"
      type="text"
      contentType={type}
      editable={true}
    />
  </li>
)});

const SortableContainer = sortableContainer(({children}) => {
  return <ul>{children}</ul>;
});

class ContentItemDraggableList extends Component {
  state = {
    items: [],
  };

  componentDidMount () {
    this.setState({ items: 
      Object.keys(this.props.contents).sort((a, b) => {
        if (this.props.type === 'funnel') {
          return this.props.contents[a].stage - this.props.contents[b].stage;
        } else {
          return this.props.contents[a].sort - this.props.contents[b].sort;
        }
      })
    });
  }

  static getDerivedStateFromProps(props, state) {
    const items = Object.keys(props.contents).sort((a, b) => {
      if (props.type === 'funnel') {
        return props.contents[a].stage - props.contents[b].stage;
      } else {
        return props.contents[a].sort - props.contents[b].sort;
      }
    });

    if (items.length !== state.items.length) {
      return {
        status: props.status,
        items
      };
    } else {
      return { status: props.status };
    }
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (prevProps.contents !== this.props.contents) {
      this.setState({ items: 
        Object.keys(this.props.contents).sort((a, b) => {
          if (this.props.type === 'funnel') {
            return this.props.contents[a].stage - this.props.contents[b].stage;
          } else {
            return this.props.contents[a].sort - this.props.contents[b].sort;
          }
        })
      });
    }

    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    const { items } = this.state;
    const newItems = arrayMove(items, oldIndex, newIndex);
    this.setState({ items: newItems });

    if (this.props.onStageChange) {
      this.props.onStageChange(newItems);
    }
  };

  render() {
    const { items } = this.state;

    return (
      <div className="dragable-list-container">
        <SortableContainer onSortEnd={this.onSortEnd} useDragHandle>
          {items.map((value, index) => (
            <SortableItem key={`item-${index}`} index={index} value={value} contents={this.props.contents} type={this.props.type} />
          ))}
        </SortableContainer>
      </div>
    );
  }
}

export default ContentItemDraggableList;
